import React, { useRef, useState, useEffect } from 'react';
import '../../styles/pages/userProfile.scss';
import { Button } from 'primereact/button';
import authApiService from '../../services/authApiService';
import Cookies from 'js-cookie';
import { Toast } from 'primereact/toast';


export default function UserProfile() {
    const token = Cookies.get('token');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [userDetail, setUserDetail] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [username, setUsername] = useState('');
    const toast = useRef(null);

    useEffect(() => {
        const name = localStorage.getItem('username');
        if (name) {
            authApiService.getAllUserQueryApi(name).then(res => {
                let userinfo = res.allUsers.edges[0].node;
                setUserDetail(userinfo);
                setFirstName(userinfo.firstName);
                setLastName(userinfo.lastName);
                setEmail(userinfo.email);
                setUsername(userinfo.username);
            });
        }

    }, []);
    const handleFirstNameChange = (e) => {
        setFirstName(e.target.value);
    }
    const handleUserNameChange = (e) => {
        setUsername(e.target.value);
    }
    const handleLastNameChange = (e) => {
        setLastName(e.target.value);
    }
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const handlePwdChange = (e) => {
        setPassword(e.target.value);
    }

    const handleConfirmPwdChange = (e) => {
        setConfirmPassword(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let updatedDetail = {};
        updatedDetail.firstName = firstName;
        updatedDetail.lastName = lastName;
        updatedDetail.email = email;
        updatedDetail.password = password;
        updatedDetail.confirmPassword = password;
        updatedDetail.username = userDetail.username;
        if (password === confirmPassword) {
            setPasswordError("");
            authApiService.updateUserInfoApi(updatedDetail, token).then(result => {
                let userDetails = result.updateUser.user;
                let userfname = userDetails.firstName + " " + userDetails.lastName;
                localStorage.setItem('usernameDisplay', userfname);
                toast.current.show({ severity: 'success', summary: "User Details are updated successfully", life: 3000, sticky: true, });

            })

        } else {
            setPasswordError('Passwords do not match');
        }
    }

    return (
        <div className='form-maincontainer'>
            <Toast ref={toast} />
            <h4>Update User Details</h4>
            <form style={{ marginTop: '2rem' }} onSubmit={handleSubmit}>
            <div className='form-mainInputField'>
                    <label className='label' htmlFor='username'>User Name:</label>
                    <input
                        className='input-formfield'
                        type='text'
                        id="username"
                        value={username}
                        disabled ={true}
                        onChange={handleUserNameChange}>
                    </input>
                </div>
                <div className='form-mainInputField'>
                    <label className='label' htmlFor='firstName'>First Name:</label>
                    <input
                        className='input-formfield'
                        type='text'
                        id="firstName"
                        value={firstName}
                        onChange={handleFirstNameChange}>
                    </input>
                </div>
                <div className='form-mainInputField'>
                    <label className='label' htmlFor='lastName'>Last Name:</label>
                    <input
                        className='input-formfield'
                        type='text'
                        id="lastName"
                        value={lastName}
                        onChange={handleLastNameChange}>
                    </input>
                </div>
                <div className='form-mainInputField'>
                    <label className='label' htmlFor='email'>Email:</label>
                    <input
                        className='input-formfield'
                        type='text'
                        id="email"
                        value={email}
                        onChange={handleEmailChange}>
                    </input>
                </div>
                <div className='form-mainInputField'>
                    <label className='label' htmlFor='password'>Password:</label>
                    <input
                        className='input-formfield'
                        type='password'
                        id="password"
                        value={password}
                        onChange={handlePwdChange}
                        required>
                    </input>
                </div>
                <div className='form-mainInputField'>
                    <label className='label' htmlFor='confirmPassword'>Confirm Password:</label>
                    <input
                        className='input-formfield'
                        type='password'
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={handleConfirmPwdChange}>
                    </input>
                </div>
                {passwordError && <p className="alert alert-danger">{passwordError}</p>}
                <Button
                    label="Submit"
                    type="submit"
                    className="mt-3"
                />
            </form>
        </div>

    )




}

